import React from 'react';
import { observer } from 'mobx-react-lite';

import { noticeError } from '@ratehub/base-ui';
import {
    PRODUCT_TYPES,
    CreditCardShape,
    CardFooterTravel,
    CardFooterCashBack,
    CardFooterLowInterest,
    CardFooterBalanceTransfer,
    CardFooterSecured,
} from '@ratehub/cc-common';


function CardFooterSelector({ cardInfo }) {
    const FooterComponent = PRODUCT_TYPE_TO_FOOTER_MAP[cardInfo.productType] || CardFooterTravel;

    if (!PRODUCT_TYPE_TO_FOOTER_MAP[cardInfo.productType]) {
        noticeError(new RangeError(`[CardFooterSelector] [${cardInfo.id} • ${cardInfo.name}]\n\t• Unexpected card product type: “${cardInfo.productType}”`));
    }

    return (
        <FooterComponent cardInfo={cardInfo} />
    );
}

CardFooterSelector.propTypes = {
    cardInfo: CreditCardShape.isRequired,
};

const PRODUCT_TYPE_TO_FOOTER_MAP = {
    [PRODUCT_TYPES.TRAVEL]: CardFooterTravel,
    [PRODUCT_TYPES.CASH_BACK]: CardFooterCashBack,
    [PRODUCT_TYPES.LOW_INTEREST]: CardFooterLowInterest,
    [PRODUCT_TYPES.BALANCE_TRANSFER]: CardFooterBalanceTransfer,
    [PRODUCT_TYPES.SECURED]: CardFooterSecured,
    // store credit does not have its own footer flavour
    [PRODUCT_TYPES.STORE_CREDIT]: CardFooterTravel,
};


export default observer(CardFooterSelector);
